import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=5331f9c0&"
import script from "./serviceDetail.vue?vue&type=script&lang=js&"
export * from "./serviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports